import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import "./PetTypeSelector.scss";
import dog_icon from '/icons/dog-icon-flat.svg';
import cat_icon from '/icons/cat-icon-flat.svg';
import horse_icon from '/icons/horse-icon-flat.svg';

const PetTypeSelector = ({ selected, setSelected }) => {
  const petTypes = useSelector((state) => state.customizer.petTypes);

  return (
    <div className="pet-type-switcher flex gap-1 items-center border-2 rounded-15">
      {petTypes.map((type) => (
        <button
          key={type}
          type="button"
          onClick={() => {
            setSelected(type);
            localStorage.setItem("petType", type);
          }}
          className={`color-swap px-4 py-2 rounded-10 transition-all ${selected === type
            ? "selected bg-primary text-white"
            : ""
            }`}
        >
          {type === 'dog' && <img src={dog_icon} alt="" />}
          {type === 'cat' && <img src={cat_icon} alt="" />}
          {type === 'horse' && <img src={horse_icon} alt="" />}

          <div>{type}</div>
        </button>
      ))}
    </div>
  );
};

PetTypeSelector.propTypes = {
  selected: PropTypes.string.isRequired,
  setSelected: PropTypes.func.isRequired
};

export default PetTypeSelector;
